import { z } from 'zod';
import { TypedApiClient } from '../index';
import { schemas } from '../../generated/api-client';
import { apiPath } from '../path';

// Import from generated schemas
const { SavedCartFirestoreResponse, CreateSavedCartDto, UpdateSavedCartDto } = schemas;

// Re-export schemas for external use
export const SavedCartResponseSchema = SavedCartFirestoreResponse;
export const CreateSavedCartSchema = CreateSavedCartDto;
export const UpdateSavedCartSchema = UpdateSavedCartDto;

export const DeleteResponseSchema = z.object({
  message: z.string(),
}).passthrough();

// Type exports
export type SavedCartResponse = z.infer<typeof SavedCartResponseSchema>;
export type CreateSavedCart = z.infer<typeof CreateSavedCartSchema>;
export type UpdateSavedCart = z.infer<typeof UpdateSavedCartSchema>;

// API factory function
export function createSavedCartsApi(client: TypedApiClient) {
  return {
    getSavedCarts: (params?: {
      storeId?: string;
    }): Promise<SavedCartResponse[]> => {
      return client.get('/saved-carts', {
        params: params as Record<string, unknown>,
        responseSchema: z.array(SavedCartResponseSchema),
      });
    },

    createSavedCart: (data: Record<string, unknown>): Promise<SavedCartResponse> => {
      return client.post('/saved-carts', {
        data,
        responseSchema: SavedCartResponseSchema,
      });
    },

    updateSavedCart: (id: string, data: Record<string, unknown>): Promise<SavedCartResponse> => {
      return client.patch(apiPath`/saved-carts/${id}`, {
        data,
        responseSchema: SavedCartResponseSchema,
      });
    },

    deleteSavedCart: (id: string): Promise<z.infer<typeof DeleteResponseSchema>> => {
      return client.delete(apiPath`/saved-carts/${id}`, {
        responseSchema: DeleteResponseSchema,
      });
    },
  };
}
